// extracted by mini-css-extract-plugin
export default {"container":"Notices_container__OXxdy","title":"Notices_title__M+q+I","notices":"Notices_notices__wjK8+","notice":"Notices_notice__WHcLm"};